import styles from "../styles/ui/ErrorComponent.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import errorImage from "../asset/Images/error (2).svg";
import React, { useEffect } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { logErrorToTelegram } from "../utility/action-helper";

function ErrorComponent({ error, resetErrorBoundary, componentStack }) {
  const dispatch = useDispatch();
  const handleReport = () => {
    console.log("error");
    resetErrorBoundary();
  };

  useEffect(() => {
    if (!componentStack) return;

    let localToken = JSON.parse(
      localStorage.getItem("aws-amplify-federatedInfo"),
    )?.token;
    if (localToken) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${localToken}`;
      let userData = JSON.parse(localStorage.getItem("aws-amplify-USERDATA"));
      const email = userData?.["cognito:username"] || "email";
      const user = userData?.["custom:custom_username"] || "username";

      const browserInfo = {
        appName: navigator?.appName, // Browser name
        appVersion: navigator?.appVersion, // Browser version
        userAgent: navigator?.userAgent, // User agent string
        platform: navigator?.platform, // Operating system/platform
        language: navigator?.language, // Browser language
      };

      if (!window.location.href?.includes("localhost")) {
        dispatch(
          logErrorToTelegram(
            user,
            email,
            "frontEnd_error",
            "#hadis_mtb",
            // error,
            `Error: ${error?.toString()}\n\nJS Stack:\n${error?.stack}\n\nReact Component Stack:\n${componentStack}\n\nBrowser Info:\n${JSON.stringify(browserInfo)}`,
            window?.location?.href,
            false,
          ),
        );
      }
    }
  }, [componentStack, dispatch, error]);

  return (
    <div className={styles.container}>
      <LazyLoadImage
        src={errorImage}
        alt="Error..."
        height="300px"
        width="100%"
        effect="blur"
        wrapperClassName={styles.preview}
      />
      <div className={styles.textError}>
        <h3>Something went wrong!</h3>
        <p>Hang tight, we'll fix it shortly!</p>
        <div className={styles.btn} onClick={handleReport}>
          Back to Home
        </div>
      </div>
    </div>
  );
}

export default ErrorComponent;
